import type { Backend } from '@freelancer/datastore/core';
import {
  getQueryParamValue,
  OrderByDirection,
} from '@freelancer/datastore/core';
import type { UserVerificationProcessesCollection } from './user-verification-processes.types';

export function userVerificationProcessesBackend(): Backend<UserVerificationProcessesCollection> {
  return {
    defaultOrder: [
      {
        field: 'id',
        direction: OrderByDirection.ASC,
      },
    ],
    fetch: (authUid, ids, query, order) => {
      return {
        endpoint: 'users/0.1/self/verifications',
        isGaf: false,
        params: {
          process_type_ids: getQueryParamValue(
            query,
            'verificationProcessTypeId',
          ),
        },
      };
    },
    push: (authUid, userVerificationProcess) => ({
      endpoint: 'users/0.1/self/verifications',
      isGaf: false,
      payload: {
        verification_process_type_id:
          userVerificationProcess.verificationProcessTypeId,
      },
    }),
    set: undefined,
    update: undefined,
    remove: undefined,
  };
}
